import styled from '@emotion/styled';
import Header from '../Header';
import NeuronComponent from './Neuron';
import getNeuronHost from './getNeuronHost';
import useNeuronUpload from './useNeuronUpload';
import useNeuronTranslateMode from './useNeuronTranslateMode';
import useNeuronStoreIdsSelect from './useNeuronStoreIdsSelect';
import useNeuronPlatformList from './useNeuronPlatformList';
import useNeuronKnowledge from './useNeuronKnowledge';

export interface NeuronProps {
  path: string;
}

const Neuron = (props: NeuronProps) => {
  const { path } = props;

  return (
    <Container>
      <Header />
      <NeuronComponent path={path} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  > header {
    flex: 0 0 auto;
    margin-bottom: 16px;
  }
  > div {
    flex: 1 0 0;
  }
`;

export default Neuron;
export {
  getNeuronHost,
  useNeuronUpload,
  useNeuronTranslateMode,
  useNeuronStoreIdsSelect,
  useNeuronPlatformList,
  useNeuronKnowledge,
};
